function Repost({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '18'} height=${(dimensions * 10) / 9} viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 5H14V8L18 4L14 0V3H2V9H4V5ZM14 15H4V12L0 16L4 20V17H16V11H14V15Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default Repost;
